// for swapping
export const SWAP = 1;
export const CHANGE_VALUE = 2;
export const HIGHLIGHT = 3;

// for option menu
export const ALGORITHM = "algo";
export const SPEED = "speed";
export const SIZE = "size";

// for updating the classes
export const CURRENT = 1;
export const NORMAL = 0;
export const DONE = 2;